import logo from "./logo.svg";
import { useEffect, useState, useRef } from "react";
import "./App.css";
import "./assests/css/style.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useSearchParams,
} from "react-router-dom";

import { AnimatePresence, motion } from "framer-motion";
import LoginPage from "./LoginPage";
import OtpPage from "./OtpPage";
import Questionnaire from "./Questionnaire";
import ImgUpload from "./ImgUpload";
import ProductDetls from "./ProductDetls";
import ProfilePage from "./ProfilePage";
import Result from "./Result";
import Termsncond from "./Termsncond";
import Onboarding from "./Onboarding";
import CameraPreview from "./CameraPreview";
import Resultnew from "./Resultnew";
import OnBoardingSlider from "./OnBoardingSlider";
import TakePhotoTop from "./TakePhotoTop";
import TakePhotoFront from "./TakePhotoFront";
import TakePhotoBack from "./TakePhotoBack";
import TakePhotoLeft from "./TakePhotoLeft";
import TakePhotoRight from "./TakePhotoRight";
import TakePhotoGallery from "./TakePhotoGallery/TakePhotoGallery";
import RegisterShortReport from "./RegisterShortReport";
import AssessmentReport from "./AssessmentReport";
import Reports from "./Reports";
import HealthAssessment from "./HealthAssessment";
import CompleteProfile from "./CompleteProfile.";
import Prescription from "./Prescription";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import translationText from "./Translations";
// dot navigation section import
import DotNavigation from "./components/DotNavigation";
import FeedBackForm from "./components/FeedbackForm";

import { useSelector, useDispatch } from "react-redux";
import {
  setbackview,
  setfrontview,
  settopview,
  setleftview,
  setrightview,
} from "./Reducers/reducer";
import { replace, useNavigate } from "react-router-dom";
import AlertComp from "./Alert";
import HeadCapture from "./HeadCapture";
import CartPage from "./components/CartPage";
import LoginShopifyUser from "./LoginShopify";
import imageCompression from "browser-image-compression";
import WebHeader from "./components/WebHeader";
import Aloxa from "./Aloxa";
import imgurl from "./assests/images/imgurl";

import DesktopLandingSection from "./DesktopLandingSection";
import { clearImagesInRedux } from "./utils/UtilityFunctions";
import Footer from "./components/Footer";
import PrescriptionList from "./PrescriptionList";
import UserPrescription from "./UserPrescription";
import LandingMiddlePage from "./components/LandingMiddlePage";
import CookieConsent from "./components/CookieConsent";
import MobileHeader from "./components/MobileHeader";
import Preview from "./Preview";
import TutorialVideo from "./components/TutorialVideo";
import GenerateQr from "./GenerateQr";
import ProtectedRoute from "./ProtectedRoute";
import ALQIQuestionnaire from "./ALQIQuestionnaire";
import SatisfactionQuestionnaire from "./SatisfactionQuestionnaire";
import HealthDeclaration from "./HealthDeclaration";
import DoctorReport from "./DoctorReport";

function App() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [from, setFrom] = useState(null)
  const prevLocation = useRef(null);
  const scrollRef = useRef(null)
  const [activeSection, setActiveSection] = useState("section0");
  const [isMobile, setIsMobile] = useState(false);
  const [takeTest, setTakeTest] = useState(false)
  const [goTo, setGoTo] = useState('home')
  const locale = useSelector((state) => state.language.langData);
  // const isFeedbackPage = location.pathname === "/feedback";

  useEffect(() => {
    const a = true;
    if (a) {
      console.log = () => {};
    }
  }, [])

  useEffect(() => {
    const div = scrollRef.current;

    const handleScroll = () => {
      const scrollTop = div.scrollTop;
      const clientHeight = div.clientHeight;

      // offset to make section switch a bit earlier (e.g. 20% of fold)
      const offset = clientHeight * 0.2;

      // Adjusted fold calculation
      const foldIndex = Math.floor((scrollTop + offset) / clientHeight);

      switch (foldIndex) {
        case 0:
          setActiveSection("SECTION0");
          break;
        case 1:
          setActiveSection("SECTION1");
          break;
        case 2:
          setActiveSection("SECTION2");
          break;
        case 3:
          setActiveSection("SECTION3");
          break;
        default:
          setActiveSection("SECTION3");
          break;
      }
    };

    div.addEventListener("scroll", handleScroll);
    return () => div.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (!window.cordova) {
      let isMobile = /iPhone|iPod|iPad|Android/i.test(navigator.userAgent);
      if (!isMobile) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
        if(location?.pathname != "/"){
          setTakeTest(true)
        } else {
          setTakeTest(true)
        }
      }
    }
  }, [isMobile, takeTest, location?.pathname]);

  useEffect(() => {
    prevLocation.current = location?.pathname;
  }, [location]);

  // useEffect(() => {
  //   let checkUserData = JSON.parse(sessionStorage.getItem("checkUser"));
  //   setFrom(searchParams.get('from'))
  //   console.log("from:::::", from);
  //   if(checkUserData && !from){
  //     navigate("/taketest");
  //   } else if(from) {
  //     setSearchParams({})
  //   }
  // }, [searchParams, setSearchParams])

  useEffect(() => {
    const hash = window.location.hash;
    const queryString = hash.split("?")[1];
    let checkUserData = JSON.parse(sessionStorage.getItem("checkUser"));
    if (queryString) {
      const queryParams = new URLSearchParams(queryString);
      if(queryParams.get("from")){
        window.location.href = window.location.href.split('?')[0]
      } else if(!queryParams.get("from") && checkUserData) {
        navigate("/taketest");
      }
    }
  }, [window.location.href]);

  useEffect(() => {
      i18next.init().then(() => {
      i18next.addResources(locale, "translation", translationText[locale]);
      i18next.changeLanguage(locale || "en").then(() => {});
    });
  }, [locale]);

  let user = localStorage.getItem("valid_user");

  const [alertopen, setalertopen] = useState(false);
  const [alertmsg, setalertmsg] = useState("progress");

  let { Topview, Backview, Leftview, Rightview, Frontview } = useSelector(
    (state) => state.user.profile
  );

  function captureimg(view, type, originfile) {
    setalertopen(true);

    // if (window.cordova) {

    //   let options = {
    //     quality: 100,
    //     destinationType: Camera.DestinationType.DATA_URL,
    //     sourceType:
    //       type == "capture"
    //         ? Camera.PictureSourceType.CAMERA
    //         : Camera.PictureSourceType.PHOTOLIBRARY,
    //     encodingType: Camera.EncodingType.JPEG,
    //     mediaType: Camera.MediaType.PICTURE,
    //     allowEdit: false,
    //     correctOrientation: true,
    //   };

    //   navigator.camera.getPicture(
    //     function (imageURI) {
    //       var raw = JSON.stringify({
    //         image: base64.split(",")[1],
    //         view: view.toLowerCase(),
    //       });

    //       var requestOptions = {
    //         method: "POST",
    //         headers: myHeaders,
    //         body: raw,
    //         redirect: "follow",
    //       };

    //       fetch(
    //         "https://aloxa.ai/flaskservice/validate_head_view",
    //         requestOptions
    //       )
    //         .then((response) => response.text())
    //         .then((result) => {
    //           if (result.is_valid === true) {
    //             if (view == "Front" || view == "Left" || view == "Right") {
    //               getBlurredFace(view, base64.split(",")[1], originfile);
    //             } else {
    //               setImages(view, base64.split(",")[1], originfile);
    //             }
    //           } else {
    //             setalertmsg(
    //               "Invalid Image! " + view + " view is required, Please Retake"
    //             );
    //             setalertopen(true);
    //             setTimeout(() => {
    //               setalertopen(false);
    //             }, 4000);
    //           }
    //         })
    //         .catch((error) => console.log("error", error));
    //     },
    //     function (message) {
    //       setalertopen(false);
    //     },
    //     options
    //   );
    // } else if (!window.cordova && type == "upload") {

    //   document.getElementById(view).click();
    //   document.getElementById(view).addEventListener("change", function () {
    //     getBase64(this.files[0])
    //       .then((base64) => {
    //         var myHeaders = new Headers();
    //         myHeaders.append("Content-Type", "application/json");

    //         var raw = JSON.stringify({
    //           image: base64.split(",")[1],
    //           view: view.toLowerCase(),
    //         });

    //         var requestOptions = {
    //           method: "POST",
    //           headers: myHeaders,
    //           body: raw,
    //           redirect: "follow",
    //         };

    //         fetch(
    //           "https://aloxa.ai/flaskservice/validate_head_view",
    //           requestOptions
    //         )
    //           .then((response) => response.text())
    //           .then((result) => {
    //             if (result.is_valid === true) {
    //               if (view == "Front" || view == "Left" || view == "Right") {
    //                 getBlurredFace(view, base64.split(",")[1], originfile);
    //               } else {
    //                 setImages(view, base64.split(",")[1], originfile);
    //               }
    //             } else {
    //               setalertmsg(
    //                 "Invalid Image! " +
    //                   view +
    //                   " view is required, Please Retake"
    //               );
    //               setalertopen(true);
    //               setTimeout(() => {
    //                 setalertopen(false);
    //               }, 4000);
    //             }
    //           })
    //           .catch((error) => console.log("error", error));
    //       })
    //       .catch((error) => {
    //         setalertopen(false);
    //         console.error(error);
    //       });
    //   });
    // }

    if (window.cordova) {
      let options = {
        quality: 100,
        destinationType: Camera.DestinationType.DATA_URL,
        sourceType:
          type == "capture"
            ? Camera.PictureSourceType.CAMERA
            : Camera.PictureSourceType.PHOTOLIBRARY,
        encodingType: Camera.EncodingType.JPEG,
        mediaType: Camera.MediaType.PICTURE,
        allowEdit: false,
        correctOrientation: true,
      };

      navigator.camera.getPicture(
        function (imageURI) {
          if (view == "Front" || view == "Left" || view == "Right") {
            getBlurredFace(view, imageURI.split(",")[1], originfile);
          } else {
            setImages(view, imageURI.split(",")[1], originfile);
          }
        },
        function (message) {
          setalertopen(false);
        },
        options
      );
    } else if (!window.cordova && type == "upload") {
      document.getElementById(view).click();
      document.getElementById(view).addEventListener("change", function () {
        getBase64(this.files[0])
          .then((base64) => {
            // You can now use the base64 value as needed
            if (view == "Front" || view == "Left" || view == "Right") {
              getBlurredFace(view, base64.split(",")[1], originfile);
            } else {
              setImages(view, base64.split(",")[1], originfile);
            }
          })
          .catch((error) => {
            setalertopen(false);
            console.error(error);
          });
      });
    }
  }

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function (error) {
        reject("Error: " + error);
      };
    });
  }

  function getBlurredFace(view, base64, originfile) {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      image: base64,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    if (requestOptions.body.length > 2) {
      fetch("https://aloxa.ai/flaskservice/process_image", requestOptions)
        .then((response) => response.text())
        .then((result) => {
          setImages(view, JSON.parse(result)["processed_image"], originfile);
        })
        .catch((error) => {
          setalertopen(false);
          setImages(view, base64);
        });
    }
  }

  async function setImages(view, imgurl, originfile) {
    setalertopen(false);
    if (originfile == "tutorial") navigate("/taketest");
    if (view == "Front") {
      dispatch(setfrontview(await compressBase64Image(imgurl)));
    } else if (view == "Top") {
      dispatch(settopview(await compressBase64Image(imgurl)));
    } else if (view == "Left") {
      dispatch(setleftview(await compressBase64Image(imgurl)));
    } else if (view == "Right") {
      dispatch(setrightview(await compressBase64Image(imgurl)));
    } else if (view == "Back") {
      dispatch(setbackview(await compressBase64Image(imgurl)));
    }
  }

  async function compressBase64Image(
    base64String,
    maxSizeMB = 1,
    maxWidthOrHeight = 800
  ) {
    // Convert Base64 to Blob
    const blob = base64ToBlob(base64String);

    // Compression options
    const options = {
      maxSizeMB: maxSizeMB, // Target size in MB
      maxWidthOrHeight: maxWidthOrHeight, // Resize dimension
      useWebWorker: true,
    };

    try {
      // Compress the image
      const compressedBlob = await imageCompression(blob, options);

      // Convert back to Base64
      const compressedBase64 = await blobToBase64(compressedBlob);

      return compressedBase64.split(",")[1];
    } catch (error) {
      return base64String; // Return original if compression fails
    }
  }

  // Convert Blob to Base64
  function blobToBase64(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
    });
  }

  function base64ToBlob(base64String, mimeType = "image/jpg") {
    const byteCharacters = atob(base64String); // Decode Base64
    const byteArrays = [];

    for (let i = 0; i < byteCharacters.length; i += 512) {
      const slice = byteCharacters.slice(i, i + 512);
      const byteNumbers = new Array(slice.length);
      for (let j = 0; j < slice.length; j++) {
        byteNumbers[j] = slice.charCodeAt(j);
      }
      byteArrays.push(new Uint8Array(byteNumbers));
    }

    return new Blob(byteArrays, { type: mimeType });
  }

  const getResult = () => {
    // navigate('/getresult')
    setalertopen(true);
    setalertmsg("analyze");
    let apiobj = {
      top_img: Topview,
      front_img: Frontview,
      back_img: Backview,
      left_img: Leftview,
      right_img: Rightview,
    };
    if (
      Topview != "" &&
      Frontview != "" &&
      Rightview != "" &&
      Leftview != "" &&
      Backview != ""
    ) {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var requestOptions = {
        method: "POST",
        body: JSON.stringify(apiobj),
        headers: myHeaders,
      };
      // https://aloxa.ai/flaskservice/predict

      fetch("https://aloxa.ai/flaskservice/predict", requestOptions)
        .then((response) => response.json())
        .then((data) => {
          setalertopen(false);
          if (data.final_hairfall_stage.stage == "Negative") {
            setalertmsg("Please provide scalp images as depicted.");
            setalertopen(true);

            clearImagesInRedux(dispatch);

            setTimeout(() => {
              setalertopen(false);
            }, 4000);
          } else {
            localStorage.setItem(
              "stage",
              JSON.stringify(data.final_hairfall_stage.stage)
            );
            navigate("/AssessmentReport");
            clearImagesInRedux(dispatch);

            fetch(
              "https://aloxa.ai/flaskservice/predict_hairtype",
              requestOptions
            )
              .then((response) => response.json())
              .then((data) => {
                localStorage.setItem(
                  "hairtype",
                  JSON.stringify(data.final_hairtype.hairtype)
                );

                fetch(
                  "https://aloxa.ai/flaskservice/predict_alopeciatype",
                  requestOptions
                )
                  .then((response) => response.json())
                  .then((result) => {
                    localStorage.setItem(
                      "alopeciatype",
                      JSON.stringify(result.final_alopeciatype.alopeciatype)
                    );

                    const controller = new AbortController();
                    const timeout = setTimeout(
                      () => controller.abort(),
                      900000
                    );
                    fetch(
                      "https://aloxa.ai/flaskservice/analyze_hair",
                      requestOptions
                    )
                      .then((response) => response.json())
                      .then((result) => {
                        localStorage.setItem(
                          "hair_count",
                          JSON.stringify(result.overall)
                        );
                      })
                      .catch((error) => console.log("error", error))
                      .finally(() => clearTimeout(timeout));
                  })
                  .catch((error) => console.log("error", error));
              })
              .catch((error) => {
                console.error("Error uploading image:", error);
              });
          }
        })
        .catch((error) => {
          setalertmsg("Error providing stage analysis.");
          setalertopen(true);
          setTimeout(() => {
            setalertopen(false);
          }, 4000);
          clearImagesInRedux(dispatch);
        });
    } else {
      setalertmsg("Please provide all images.");
      setalertopen(true);
      setTimeout(() => {
        setalertopen(false);
      }, 4000);
    }
  };

  const PageWrapper = ({ children }) => {
    return (
      <motion.div
        initial={{ width: "0vw", x: "100vw" }}
        animate={{ width: "100vw", x: 0 }}
        transition={{ duration: 0.5, origin: 1 }}
      >
        {children}
      </motion.div>
    );
  };

  //  scroll section useRef dot navigation
  const sectionRefs = {
    section0: useRef(null),
    section1: useRef(null),
    section2: useRef(null),
    section3: useRef(null),
  };

  const scrollTo = (ref, section) => {
    setActiveSection(section);
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleArrow = (to) => {
    let goTo = to
    if(to === "home"){
      setGoTo("how-it-works")
      setActiveSection("section1")
    } else if(to === "how-it-works"){
      setGoTo("sample-report-review")
      setActiveSection("section2")
    } else if(to === "sample-report-review"){
      setGoTo("desktopLanding")
      setActiveSection("section3")
    } else if(to === "desktopLanding"){
      setGoTo("home")
      setActiveSection("section0")
    }
    const element = document.getElementById(goTo);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" }); // Smooth scroll
    }
    return(
      <DotNavigation
        sectionRefs={sectionRefs}
        activeSection={activeSection}
      />
    )
  }

  return (
    <div className="App" ref={scrollRef}>
      <AnimatePresence>
        <div className="d-none desktop-header">
          <WebHeader></WebHeader>
        </div>

        <>
          <div className="DesktopWebDiv" ref={sectionRefs.section0}>
            <div className="w-100 mainWrapper">
              {/* {isMobile && !takeTest && <MobileHeader></MobileHeader>} */}

              {!isMobile && !takeTest && (
                <DesktopLandingSection></DesktopLandingSection>
              )}

              <div className={isMobile ? "mobileSectionsDiv" : "mobileSectionsDiv desktopBg"}>
                <div className={isMobile ? "" : "mobileholderdiv"}>
                  <Routes location={location} key={location.pathname}>
                    <Route path="/loginpage" element={<LoginPage />} />
                    <Route 
                      path="/profilepage" 
                      element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<ProfilePage/>}/>} 
                    />
                    <Route 
                      path="/questionnaire" 
                      element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<Questionnaire/>}/>} 
                    />
                    <Route 
                      path="/result" 
                      element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<Result/>}/>} 
                    />
                    <Route 
                      path="/termsncond" 
                      element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<Termsncond/>}/>} 
                    />
                    <Route 
                      path="/onboarding" 
                      element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<Onboarding/>}/>} 
                    />
                    <Route 
                      path="/camera" 
                      element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<CameraPreview/>}/>} 
                    />
                    {/* Old pages new design */}
                    <Route 
                      path="/loginpage" 
                      element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<LoginPage/>}/>} 
                    />
                    <Route 
                      path="/otppage" 
                      element={<OtpPage/>} 
                    />
                    <Route
                      path="/onboardingslider"
                      element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<OnBoardingSlider/>}/>}
                    />
                    {/* take photo image upload */}
                    <Route 
                      path="/taketest" 
                      element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<ImgUpload/>}/>} 
                    />
                    {/* Assessment Full Report page */}
                    <Route 
                      path="/resultnew" 
                      element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<Resultnew/>}/>} 
                    />
                    {/* product details add cart */}
                    <Route 
                      path="/productdetails" 
                      element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<ProductDetls/>}/>} 
                    />
                    {/* Aloxa module */}
                    <Route 
                      path="/aloxa" 
                      element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<Aloxa/>}/>} 
                    />
                    {/* Reports Page */}
                    <Route 
                      path="/reports" 
                      element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<Reports/>}/>} 
                    />
                    {/* Prescription List Page */}
                    <Route 
                      path="/prescriptions" 
                      element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<PrescriptionList/>}/>} 
                    />
                    {/* User Prescription Page */}
                    <Route
                      path="/userprescription"
                      element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<UserPrescription/>}/>}
                    />
                    {/* Doctor Report Page */}
                    <Route
                      path="/doctorreport"
                      element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<DoctorReport/>}/>}
                    />
                    {/* Health Declaration Page */}
                    <Route
                      path="/healthdeclaration"
                      element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<HealthDeclaration/>}/>}
                    />
                    {/* new pages routing  */}
                    <Route
                      path="/takephototop"
                      element={
                        <ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<TakePhotoTop
                            capture={(type, originfile) =>
                              captureimg("Top", type, originfile)
                            }
                          />}
                        />
                      }
                    />
                    <Route
                      path="/takephotofront"
                      element={
                        <ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<TakePhotoFront
                            capture={(type, originfile) =>
                              captureimg("Front", type, originfile)
                            }
                          />}
                        />
                      }
                    />
                    <Route
                      path="/takephotoback"
                      element={
                        <ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<TakePhotoBack
                            capture={(type, originfile) =>
                              captureimg("Back", type, originfile)
                            }
                          />}
                        />        
                      }
                    />
                    <Route
                      path="/takephotoleft"
                      element={
                        <ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<TakePhotoLeft
                            capture={(type, originfile) =>
                              captureimg("Left", type, originfile)
                            }
                          />}
                        />
                      }
                    />
                    <Route
                      path="/takephotoright"
                      element={
                        <ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<TakePhotoRight
                            capture={(type, originfile) =>
                              captureimg("Right", type, originfile)
                            }
                          />}
                        />
                      }
                    />
                    {/* <Route
                      path="/preview"
                      element={
                        <TakePhotoGallery
                          capture={(view, type, originfile) =>
                            captureimg(view, type, originfile)
                          }
                        />
                      }
                    /> */}
                    {/* tutorial page */}
                    <Route
                      path="/tutorial"
                      element={<ProtectedRoute element={<TutorialVideo/>}/>}
                    />
                    {/* new preview page */}
                    <Route
                      path="/preview"
                      element={<ProtectedRoute element={<Preview/>}/>}
                    />
                    {/* generate qr page*/}
                    <Route
                      path="/generateqr"
                      element={<ProtectedRoute element={<GenerateQr/>}/>}
                    />
                    <Route
                      path="/AssessmentReport"
                      element={<ProtectedRoute element={<AssessmentReport/>}/>}
                    />
                    {/* short report register  */}
                    <Route
                      path="/RegisterShortReport"
                      element={<ProtectedRoute element={<RegisterShortReport/>}/>}
                    />
                    <Route
                      path="/HealthAssessment"
                      element={<ProtectedRoute element={<HealthAssessment/>}/>}
                    />
                    <Route
                      path="/CompleteProfile"
                      element={<ProtectedRoute element={<CompleteProfile/>}/>}
                    />
                    <Route 
                      path="/Prescription" 
                      element={<ProtectedRoute element={<Prescription/>}/>} 
                    />
                    <Route 
                      path="/CartPage" 
                      element={<ProtectedRoute element={<CartPage/>}/>} 
                    />
                    <Route 
                      path="/headcapture" 
                      element={<ProtectedRoute element={<HeadCapture/>}/>} 
                    />
                    <Route
                      path="/loginshopifyuser"
                      element={<ProtectedRoute element={<LoginShopifyUser/>}/>}
                    />
                    <Route
                      path="/"
                      element={
                        user == null ? (
                          window.cordova ? (
                            <Onboarding />
                          ) : isMobile ? (
                            // <DesktopLandingSection />
                            <LoginPage />
                          ) : (
                            <LoginPage />
                          )
                        ) : (
                          // <ImgUpload />
                          <Reports />    // Default landing page if already logged in
                        )
                      }
                    />
                    {/* <Route path="/feedback" element={<FeedBackForm />} /> */}
                    <Route 
                      path="/alqi-questionnaire" 
                      element={<ProtectedRoute element={<ALQIQuestionnaire/>}/>}   
                    />
                    <Route 
                      path="/satisfaction-questionnaire" 
                      element={<ProtectedRoute element={<SatisfactionQuestionnaire/>}/>} 
                    />
                  </Routes>
                </div>
                {/* <div className="feedbackContainer">
                <Routes>
                  <Route path="/feedback" element={<FeedBackForm />} />
                </Routes>
              </div> */}
              </div>

              {/* <span className="d-none dotNavigationSection">
                <DotNavigation
                  sectionRefs={sectionRefs}
                  onDotClick={scrollTo}
                  activeSection={activeSection}
                  scrollRef={scrollRef}
                />
              </span> */}
            </div>

            {/* {!isMobile && (
              <div className="arrowDivSection cursor-pointer">
                <img
                  className={goTo === "desktopLanding" && "upArrow"}
                  src={imgurl.ArrowGif}
                  onClick={() => handleArrow(goTo)}
                ></img>
              </div>
            )}
            {!takeTest && <LandingMiddlePage sectionRefs={sectionRefs} />} */}
            {/* {isMobile && !takeTest && (
            <div className="takeTestIcon">
              <div className="takeTestSection" 
                onClick={() => {
                  setTakeTest(true)
                  navigate('/loginpage')
                }}
              >
               
                <h5>Take the Test</h5>
              </div>
            </div>
          )} */}
            {
              (
                !localStorage.getItem('cookieConsent') || 
                localStorage.getItem('cookieConsent').toUpperCase() != 'ACCEPTED'
              ) &&
              <CookieConsent />
            }
          </div>
        </>
      </AnimatePresence>
      {!takeTest && <Footer />}

      <input type="file" id="Front" accept="image/png, image/jpeg" hidden />
      <input type="file" id="Right" accept="image/png, image/jpeg" hidden />
      <input type="file" id="Left" accept="image/png, image/jpeg" hidden />
      <input type="file" id="Top" accept="image/png, image/jpeg" hidden />
      <input type="file" id="Back" accept="image/png, image/jpeg" hidden />
      <AlertComp open={alertopen} msg={alertmsg} type={"success"} />
    </div>
  );
}

export default App;
